<template>
  <!-- 第三步：平台服务商基本信息 -->
  <div class="serviceInfo">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="165px"
      class="form-wrap"
      :disabled="disabled"
    >
      <el-form-item label="平台服务商名称：" prop="serviceName">
        <el-input v-model="form.serviceName" placeholder="请输入" clearable />
      </el-form-item>
      <el-form-item label="平台网址：" prop="serviceUrl">
        <el-input v-model="form.serviceUrl" placeholder="请输入" clearable />
      </el-form-item>
      <el-form-item label="企业地址：" prop="serviceAddr">
        <el-input v-model="form.serviceAddr" placeholder="请输入" clearable />
      </el-form-item>
      <el-form-item label="企业简介：" prop="introduction">
        <el-input
          v-model="form.introduction"
          placeholder="请输入"
          clearable
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 6 }"
        />
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人：" prop="contact">
            <el-input v-model="form.contact" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话：" prop="contactTel">
            <el-input v-model="form.contactTel" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人职务：" prop="contactJob">
            <el-input v-model="form.contactJob" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人邮箱：" prop="contactMail">
            <el-input v-model="form.contactMail" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { saveThirdInfo, getThirdInfo } from "../../utils/interface";
const form = () => {
  return {
    serviceName: "", // 企业名称
    serviceUrl: "", // 平台网址
    serviceAddr: "", // 企业地址
    introduction: "", // 企业简介
    contact: "", // 联系人
    contactTel: "", // 联系电话
    contactJob: "", // 联系人职务
    contactMail: "" // 联系人邮箱
  };
};
const rules = () => {
  return {
    serviceName: [
      { required: true, message: "请输入企业名称", trigger: "blur" }
    ],
    serviceUrl: [
      { required: true, message: "请输入平台网址", trigger: "blur" }
    ],
    serviceAddr: [
      { required: true, message: "请输入企业地址", trigger: "blur" }
    ],
    introduction: [
      { required: true, message: "请输入企业简介", trigger: "blur" }
    ],
    contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
    contactTel: [
      { required: true, message: "请输入联系电话", trigger: "blur" }
    ],
    contactJob: [
      { required: true, message: "请输入联系人职务", trigger: "blur" }
    ],
    contactMail: [
      { required: true, message: "请输入联系人邮箱", trigger: "blur" }
    ]
  };
};
export default {
  name: "",
  components: {},
  props: {
    projectId: String
  },
  data() {
    return {
      form: form(),
      rules: rules(),
      disabled: false,
      uuid: ""
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    if (this.$route.query.projectId) {
      // console.log('第三步')
      this.getThirdInfo(this.$route.query.projectId);
    }
  },
  methods: {
    /* 获取第三步详情 */
    getThirdInfo(projectId) {
      getThirdInfo(projectId).then(res => {
        if (res.success && Object.keys(res.data).length > 0) {
          this.form = res.data;
          this.disabled =
            this.$route.query.status == "INIT" ||
            this.$route.query.status == "REJECT"
              ? false
              : true;
          this.uuid = res.data.uuid;
        } else {
          this.form = form();
        }
      });
    },
    /* 第三步保存 */
    save() {
      // console.log('第三步保存')
      this.$refs.form.validate(valid => {
        if (valid) {
          saveThirdInfo({
            policyUuid: this.$route.query.policyUuid,
            userUuid: this.$store.state.isUsermessage.uuid,
            projectId: this.projectId,
            ...this.form,
            uuid: this.uuid
          }).then(res => {
            if (res.success) {
              this.$message({
                message: res.message,
                type: "success"
              });
              this.uuid = res.data.uuid;
              this.$parent.activeStep++;
            } else {
              this.$message({
                message: res.message,
                type: "error"
              });
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";

.serviceInfo {
  min-height: 300px;
  margin-bottom: 35px;
  border-radius: 12px;

  .form-wrap {
    padding: 10px 20px;
    .bs();

    p {
      font-size: 14px;
      color: #888888;
      line-height: 1.7;
      margin-bottom: 40px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/projectApply/serviceInfo.vue